import { useContext } from 'react'
import { GetAtributosEquivalencias, GetAtributosEquivalenciasValoresBulk } from '../services/atributos.service'
import { useAppStore } from '../../../store/app-store'
import { TenantsContext } from '../../../context/tenants.context'

const useAtributos = () => {
  const codLocal = useAppStore((state) => state.codLocal)
  const { tenant } = useContext(TenantsContext)

  const getAtributos = async () => {
    try {
      const { data: atributos } = await GetAtributosEquivalencias(tenant.path, codLocal)
      return atributos
    } catch (error) {
      throw new Error('Error al obtener los atributos')
    }
  }

  const getAtributosValoresBulk = async (ids: number[]) => {
    try {
      const { data: valores } = await GetAtributosEquivalenciasValoresBulk(tenant.path, codLocal, ids)
      return valores
    } catch (error) {
      throw new Error('Error al obtener los valores de atributos')
    }
  }

  return { getAtributos, getAtributosValoresBulk }
}

export default useAtributos
